/*
*  AGP events
*  Fichier de gestion users
*/

import $ from "jquery";
import 'jquery-ui';
// import 'bootstrap';
// import 'bootstrap-table/dist/bootstrap-table.js';

import AirDatepicker from 'air-datepicker';
import localeFr from 'air-datepicker/locale/fr';

import Common from "./agp_common";
// import "../AGP/PLUGS/bootstrap-table-master/dist/bootstrap-table.min.js";
// //import "../AGP/PLUGS/bootstrap-table-master/dist/locale/bootstrap-table-fr-FR.min.js";
const Cookies = require('js-cookie');

let user = {};
user.canvas;
user.video;
user.stream;
user.videoHeight = 0;
user.videoWidth = 0;
user.acceptedImageTypes = ['image/jpeg', 'image/png'];
user.inputFile;
user.view_user;
user.view_user_load = false;
user.mod_multiple = false;
user.requiredFieldsArray;
user.emailRequired = false;
user.currentFilter = "";

// parametres tables
user.param_limit = 150;
user.param_filter = "";
user.param_offset = 0;

export default class Users {

    constructor(el) {
        this.DOM = {el: el};
    }

    init() {
        let _this = this;

        _this.initsearch(this);
        _this.initModification(this);
        _this.user_distributed(this);


        // si chef equipe leader sélectionné, ajoute etoile sur mail obligatoire
        $('#_leader').change(function () {

            var input = $("input[name=user_mail]");
            var emailFieldIndex = user.requiredFieldsArray.indexOf(input[0]);
            var label = $("label.control-label[for=user_mail]");

            // Check if the checkbox is checked
            if ($(this).is(':checked') && emailFieldIndex === -1) {
                user.requiredFieldsArray.push(input[0]);
                label.html("Email *");
                input.prop('required', true);
            } else {
                if (user.emailRequired === false) {
                    user.requiredFieldsArray.splice(emailFieldIndex, 1);
                    label.html("Email");
                    input.prop('required', false);
                }
            }
        });

        // empêcher de soumettre deux fois le formulaire duplication
        $(document).on("submit", "form._btn_duplicate", function (event) {
            if ($(this).data("submitted")) {
                event.preventDefault();
            } else {
                $(this).data("submitted", true);
                $(this).find('button[type="submit"]').prop("disabled", true);
            }
        });

        // formulaire saisie / ajout nouvelle société
        $(document).on("click", "._new_society", function () {
            $(".input_add_new[data-new=society]").show();
            $("select[name=user_societe]").hide();
            $("select[name=user_societe]").next().hide();
        });

        $(document).on("click", "._close_add_new", function () {
            var _type = $(this).parent().data("new");
            //alert(_type);
            $(".input_add_new[data-new=" + _type + "]").hide();
            $(".input_add_new[data-new=" + _type + "] input").val("");
            $("select[name=user_societe]").show();
            $("select[name=user_societe]").next().show();
            $("select[name=user_societe]").multipleSelect('setSelects', []);
        });


        // drop down filter chef equipe / resposnable inscription / blacklist
        $('.drop_btn span').on('click', function () {


            $("._btn_filter").addClass("_activ");

            user.currentFilter = $(this).data('value');

            var _name_btn = "Chefs d'équipe";

            if (user.currentFilter === "resp") {
                _name_btn = "Resp. inscription";
            }

            if (user.currentFilter === "blacklist") {
                _name_btn = "Blacklistés";
            }
            user.param_filter = user.currentFilter;
            $("._table_users").bootstrapTable("refresh");
            //alert(user.currentFilter);
            //return false;
            //$('._table_users').bootstrapTable('filterBy', {[user.currentFilter]: '<span class="_step _Y">Y</span>'});
            $("._name_btn").html(_name_btn);
            var icon = $('#reinitFilter');
            icon.removeClass('fa-chevron-down');
            icon.addClass('fa-xmark');

        });


        $("._btn_reinit").on("click", function () {
            if (user.currentFilter != "") {
                user.currentFilter = "";
                user.param_filter = user.currentFilter;
                $("._table_users").bootstrapTable("refresh");
                _this.reinitFilters();
            }
        });


        // MODAL / SAVES + navigation fiche suivante (liste filtrée)
        var agpNavStorageKey = function (editionId) {
            var id = parseInt(editionId, 10);
            return id > 0 ? ("agpUsersNavList:" + id) : "";
        };
        var agpResolveEditionId = function () {
            var eid = parseInt($("input[name=edition_id]").val(), 10);
            if (eid > 0) {
                return eid;
            }
            try {
                var m = String(window.location.pathname || "").match(/\/editions\/(\d+)\//);
                return m ? parseInt(m[1], 10) : 0;
            } catch (e) {
                return 0;
            }
        };
        var agpStoreNavList = function (ids, editionId) {
            var eid = parseInt(editionId, 10) || agpResolveEditionId();
            var key = agpNavStorageKey(eid);
            if (!key) {
                return [];
            }
            var clean = [];
            (Array.isArray(ids) ? ids : []).forEach(function (raw) {
                var id = parseInt(raw, 10);
                if (!isNaN(id) && id > 0 && clean.indexOf(id) === -1) {
                    clean.push(id);
                }
            });
            try {
                window.sessionStorage.setItem(key, JSON.stringify(clean));
            } catch (e) {
            }
            if (typeof window.agpUsersStoreNavList === "function") {
                try {
                    window.agpUsersStoreNavList(clean, eid);
                } catch (e2) {
                }
            }
            return clean;
        };
        var agpLoadNavList = function (editionId) {
            var eid = parseInt(editionId, 10) || agpResolveEditionId();
            if (typeof window.agpUsersLoadNavList === "function") {
                try {
                    var fromHelper = window.agpUsersLoadNavList(eid);
                    if (Array.isArray(fromHelper) && fromHelper.length) {
                        return fromHelper.map(function (v) {
                            return parseInt(v, 10);
                        }).filter(function (id) {
                            return id > 0;
                        });
                    }
                } catch (e) {
                }
            }
            var key = agpNavStorageKey(eid);
            if (!key) {
                return [];
            }
            try {
                var parsed = JSON.parse(window.sessionStorage.getItem(key) || "[]");
                if (!Array.isArray(parsed)) {
                    return [];
                }
                return parsed.map(function (v) {
                    return parseInt(v, 10);
                }).filter(function (id) {
                    return id > 0;
                });
            } catch (e2) {
                return [];
            }
        };
        var agpReadSearchCriteria = function (editionId) {
            var eid = String(editionId || agpResolveEditionId());
            var raw = null;
            try {
                if (typeof Cookies !== "undefined") {
                    raw = Cookies.get("searchCriteriaCookie");
                }
            } catch (e) {
            }
            if (!raw) {
                try {
                    raw = window.sessionStorage.getItem("searchCriteriaCache");
                } catch (e2) {
                }
            }
            if (!raw) {
                return null;
            }
            try {
                var parsed = JSON.parse(raw);
                if (parsed && parsed.edition_id && String(parsed.edition_id) !== eid) {
                    return null;
                }
                return parsed;
            } catch (e3) {
                try {
                    var decoded = JSON.parse(decodeURIComponent(raw));
                    if (decoded && decoded.edition_id && String(decoded.edition_id) !== eid) {
                        return null;
                    }
                    return decoded;
                } catch (e4) {
                    return null;
                }
            }
        };
        var agpBuildMatchingIdsUrl = function (editionId) {
            var eid = parseInt(editionId, 10) || agpResolveEditionId();
            if (eid < 1) {
                return "";
            }
            // Si le tableau liste est présent, réutilise son data-url (déjà filtré).
            if (typeof window.agpUsersFetchMatchingIds === "function" && $("._table_users").length > 0) {
                return "__use_table_helper__";
            }
            var base = "/data-users/" + eid;
            var criteria = agpReadSearchCriteria(eid);
            if (typeof window.__agpUserSearchWithCriteriaQuery === "function" && criteria) {
                try {
                    return window.__agpUserSearchWithCriteriaQuery(base, criteria);
                } catch (e) {
                }
            }
            var params = new URLSearchParams();
            params.set("with_matching_ids", "1");
            params.set("limit", "1");
            params.set("offset", "0");
            if (criteria && typeof criteria === "object") {
                var joinIds = function (arr) {
                    return Array.isArray(arr) ? arr.map(String).filter(Boolean).join(",") : "";
                };
                var societes = joinIds(criteria.societes);
                var categories = joinIds(criteria.categories);
                var sscategories = joinIds(criteria.sscategories);
                var leaders = joinIds(criteria.leaders);
                var zones = joinIds(criteria.zones);
                var jours = joinIds(criteria.jours);
                if (societes) params.set("societes", societes);
                if (categories) params.set("category_id", categories);
                if (sscategories) params.set("category_ss_id", sscategories);
                if (leaders) params.set("leaders", leaders);
                if (zones) params.set("zones", zones);
                if (jours) params.set("jours", jours);
                var mapText = {
                    search_name: criteria.name,
                    search_surname: criteria.surname,
                    search_mail: criteria.mail,
                    search_function: criteria.fonction,
                    search_comm: criteria.comm,
                    search_photo: criteria.photo,
                    search_created_by: criteria.created_by,
                    user_activ: criteria.activ,
                    search_badge_validate: criteria.badge_validate,
                    search_badge_blacklist: criteria.badge_blacklist,
                    search_badge_confirm: criteria.badge_confirm,
                    search_badge_print: criteria.badge_print,
                    search_badge_distributed: criteria.badge_distributed
                };
                Object.keys(mapText).forEach(function (key) {
                    var val = String(mapText[key] == null ? "" : mapText[key]).trim();
                    if (val !== "") {
                        params.set(key, val);
                    }
                });
                var sortField = String(criteria.tri || "").trim();
                var sortOrder = String(criteria.tri_type || "").toLowerCase() === "desc" ? "desc" : "asc";
                if (sortField !== "") {
                    params.set("sort", sortField);
                    params.set("order", sortOrder);
                }
                var quick = String(criteria.quick_filter || "").trim();
                if (quick !== "") {
                    params.set("filter", quick);
                }
            }
            var qs = params.toString();
            return qs ? (base + "?" + qs) : base;
        };
        var agpFetchMatchingIds = function (editionId, callback) {
            var done = typeof callback === "function" ? callback : function () {
            };
            var eid = parseInt(editionId, 10) || agpResolveEditionId();
            if (typeof window.agpUsersFetchMatchingIds === "function" && $("._table_users").length > 0) {
                window.agpUsersFetchMatchingIds(function (ids) {
                    done(agpStoreNavList(ids || [], eid));
                });
                return;
            }
            var url = agpBuildMatchingIdsUrl(eid);
            if (!url || url === "__use_table_helper__") {
                done([]);
                return;
            }
            if (url.indexOf("with_matching_ids=") === -1) {
                url += (url.indexOf("?") >= 0 ? "&" : "?") + "with_matching_ids=1&limit=1&offset=0";
            }
            $.getJSON(url)
                .done(function (data) {
                    var ids = (data && data.matching_user_ids) || [];
                    done(agpStoreNavList(ids, eid));
                })
                .fail(function () {
                    done([]);
                });
        };
        var applyFicheAdjacentNav = function (ids) {
            var currentId = parseInt($("input[name=user_id]").val(), 10);
            var editionId = agpResolveEditionId();
            if (!currentId || !editionId) {
                return {prev: 0, next: 0};
            }
            var clean = agpStoreNavList(ids, editionId);
            var idx = clean.indexOf(currentId);
            var nextId = (idx >= 0 && idx < clean.length - 1) ? clean[idx + 1] : 0;
            var prevId = (idx > 0) ? clean[idx - 1] : 0;
            var base = "/editions/" + editionId + "/users/";

            $("input[name=next_user]").val(nextId > 0 ? String(nextId) : "");
            if (nextId > 0) {
                $(".btn_next_user").attr("href", base + nextId).removeClass("_nav_disabled").show();
                $(".save_user_next").closest("li").show();
            } else {
                $(".btn_next_user").attr("href", "#").addClass("_nav_disabled");
                // garder le bouton visible : en fin de liste, save_next renvoie à la liste
                $(".save_user_next").closest("li").show();
            }
            if (prevId > 0) {
                $(".btn_prev_user").attr("href", base + prevId).removeClass("_nav_disabled").show();
            } else {
                $(".btn_prev_user").attr("href", "#").addClass("_nav_disabled");
            }
            return {prev: prevId, next: nextId};
        };
        var resolveNextUserId = function (currentId, editionId) {
            var ids = agpLoadNavList(editionId);
            if ((!ids || !ids.length) && Array.isArray(window.__agpUsersMatchingIds) && window.__agpUsersMatchingIds.length) {
                ids = window.__agpUsersMatchingIds.slice();
            }
            var idx = ids.indexOf(parseInt(currentId, 10));
            if (idx >= 0 && idx < ids.length - 1) {
                return ids[idx + 1];
            }
            return 0;
        };

        $(document).on("click", ".save_user_stay", function () {
            $("input[name=save_stay]").val(true);
        });

        $(document).on("click", ".save_user_next", function (e) {
            $("input[name=save_next]").val("true");
            var $btn = $(this);
            var form = $btn.closest("form").get(0);
            var currentId = parseInt($("input[name=user_id]").val(), 10);
            var editionId = agpResolveEditionId();
            var nextId = parseInt($("input[name=next_user]").val(), 10) || resolveNextUserId(currentId, editionId);
            if (nextId > 0) {
                $("input[name=next_user]").val(String(nextId));
                return;
            }

            // Liste absente (vue fiche dédiée sans tableau) : fetch puis submit.
            e.preventDefault();
            e.stopImmediatePropagation();
            agpFetchMatchingIds(editionId, function (ids) {
                applyFicheAdjacentNav(ids);
                var resolved = resolveNextUserId(currentId, editionId);
                $("input[name=next_user]").val(resolved > 0 ? String(resolved) : "");
                $("input[name=save_next]").val("true");
                if (!form) {
                    return;
                }
                if (typeof form.requestSubmit === "function") {
                    form.requestSubmit($btn.get(0));
                } else {
                    // Fallback : clone le name/value du bouton.
                    var hidden = document.createElement("input");
                    hidden.type = "hidden";
                    hidden.name = "_btn";
                    hidden.value = "save_user";
                    form.appendChild(hidden);
                    form.submit();
                }
            });
        });

        var setupFicheNavigationFromList = function () {
            if ($("._modal_user._show").length < 1) {
                return;
            }
            var currentId = parseInt($("input[name=user_id]").val(), 10);
            var editionId = agpResolveEditionId();
            if (!currentId || !editionId) {
                return;
            }

            var stored = agpLoadNavList(editionId);
            if (stored.length && stored.indexOf(currentId) >= 0) {
                applyFicheAdjacentNav(stored);
            }

            // Toujours rafraîchir depuis data-users (avec critères cookie) — marche aussi sans tableau.
            agpFetchMatchingIds(editionId, function (ids) {
                if (ids && ids.length) {
                    applyFicheAdjacentNav(ids);
                    return;
                }
                try {
                    if ($("._table_users").length > 0) {
                        var rows = $("._table_users").bootstrapTable("getData") || [];
                        var pageIds = rows.map(function (row) {
                            return parseInt(row && row.id != null ? row.id : 0, 10);
                        }).filter(function (id) {
                            return id > 0;
                        });
                        if (pageIds.length) {
                            applyFicheAdjacentNav(pageIds);
                        }
                    }
                } catch (e) {
                }
            });
        };

        setupFicheNavigationFromList();

        // Depuis la liste : attendre la mémorisation de la liste filtrée avant d'ouvrir la fiche.
        $(document).on("click", "._table_users a[href*='/users/']", function (e) {
            var href = String(this.href || "");
            if (!/\/users\/\d+(?:\/)?(?:#.*)?$/.test(href) || href.indexOf("/print") !== -1 || href.indexOf("/tab/") !== -1) {
                return;
            }
            e.preventDefault();
            e.stopImmediatePropagation();
            var editionId = agpResolveEditionId();
            var go = function () {
                window.location.href = href;
            };
            if (window.__agpUsersMatchingIds && window.__agpUsersMatchingIds.length) {
                agpStoreNavList(window.__agpUsersMatchingIds.slice(), editionId);
                go();
                return;
            }
            var stored = agpLoadNavList(editionId);
            if (stored.length) {
                go();
                return;
            }
            agpFetchMatchingIds(editionId, function (ids) {
                if ((!ids || !ids.length) && $("._table_users").length) {
                    try {
                        var rows = $("._table_users").bootstrapTable("getData") || [];
                        agpStoreNavList(rows.map(function (row) {
                            return row && row.id;
                        }), editionId);
                    } catch (err) {
                    }
                }
                go();
            });
        });

        $(document).on("click", "._reinit_search", function () {
            Cookies.remove('searchCriteriaCookie');
        });

        $('input[required]').on('keyup', function () {
            $(this).removeClass('_field_error');
        });

        $(document).on("click", "button[value=clean_search]", function () {
            Cookies.remove('searchCriteriaCookie');
            $('input[type="text"], textarea, select').val('');
            $("select.multiple-select").multipleSelect('refresh');
            $("select.multiple-select").multipleSelect('setSelects', []);
        });

        $(document).on("click", ".__open_doublons", function () {
            _this.initDoublons($("input[name=edition_id]").val());
        });
        $(document).on("click", "._close_modal_doublons", function () {
            $("._modal_user_doublons").removeClass("_show");
            $("html,body").css("overflow", "auto");
        });

        $(document).on("click", ".close_wait", function () {
            $(".__wait_load").removeClass("_show");
        });

        function refillCloneBulkChildSelect($selS, children, parents, pid) {
            $selS.empty();
            var list = children[String(pid)] || children[pid];
            if (list && list.length) {
                list.forEach(function (c) {
                    $selS.append($("<option/>").val(c.id).text(c.label));
                });
            } else if (pid) {
                var pl = (parents || []).filter(function (x) {
                    return String(x.id) === String(pid);
                })[0];
                $selS.append($("<option/>").val(pid).text(pl && pl.label ? pl.label : "(catégorie)"));
            }
        }

        function persistCloneBulkMapping(targetEdition, map) {
            var sourceEdition = parseInt($("input[name=edition_id]").first().val(), 10) || 0;
            var target = parseInt(targetEdition, 10) || 0;
            if (sourceEdition < 1 || target < 1 || !map || typeof map !== "object") {
                return;
            }
            if (!window.AGP_CLONE_BULK || !window.AGP_CLONE_BULK.mappingSaveUrl) {
                return;
            }
            var params = new URLSearchParams();
            params.set("source_edition_id", String(sourceEdition));
            params.set("target_edition_id", String(target));
            params.set("payload", JSON.stringify({categories: map}));
            fetch(window.AGP_CLONE_BULK.mappingSaveUrl, {
                method: "POST",
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded",
                    "X-Requested-With": "XMLHttpRequest",
                },
                body: params,
                credentials: "same-origin",
            }).catch(function () {
                // no-op
            });
        }

        function prefillCloneBulkMapping($m, savedMap, children, parents) {
            if (!savedMap || typeof savedMap !== "object") {
                return;
            }
            $m.find(".__clone_bulk_map_table tbody tr").each(function () {
                var $tr = $(this);
                var $p = $tr.find(".__map_parent");
                var $s = $tr.find(".__map_ss");
                var key = $p.attr("data-key");
                if (!key || !savedMap[key] || typeof savedMap[key] !== "object") {
                    return;
                }
                var parentId = parseInt(savedMap[key].c, 10) || 0;
                var childId = parseInt(savedMap[key].s, 10) || 0;
                if (parentId < 1 || childId < 1) {
                    return;
                }

                // parent valide ?
                if ($p.find("option[value='" + parentId + "']").length < 1) {
                    return;
                }

                $p.val(String(parentId));
                refillCloneBulkChildSelect($s, children, parents, parentId);

                // child valide pour ce parent ?
                if ($s.find("option[value='" + childId + "']").length > 0) {
                    $s.val(String(childId));
                }
            });
        }

        function renderCloneBulkModal($m, previewData, targetEdition, ids) {
            var $tbody = $m.find(".__clone_bulk_map_table tbody");
            $tbody.empty();
            var parents = previewData.target_parents || [];
            var children = previewData.target_children || {};
            var expandedCount = parseInt(previewData.expanded_count || 0, 10) || 0;

            if (expandedCount > 0) {
                var currentLabel = ($m.find(".__clone_bulk_target_label").text() || "").trim();
                if (currentLabel !== "") {
                    currentLabel += " ";
                }
                currentLabel +=
                    "Inclut automatiquement " +
                    expandedCount +
                    " fiche(s) rattachée(s) à des responsables sélectionnés.";
                $m.find(".__clone_bulk_target_label").text(currentLabel);
            }

            (previewData.pairs || []).forEach(function (pair) {
                var $tr = $("<tr/>");
                $tr.append($("<td/>").text(pair.label_cat));
                $tr.append($("<td/>").text(pair.label_ss));
                var $selP = $('<select class="form-select __map_parent"/>').attr("data-key", pair.key);
                $selP.append($('<option value=""/>').text("—"));
                parents.forEach(function (p) {
                    $selP.append($("<option/>").val(p.id).text(p.label));
                });
                $tr.append($("<td/>").append($selP));
                var $selS = $('<select class="form-select __map_ss"/>').attr("data-key", pair.key);
                $tr.append($("<td/>").append($selS));
                $tbody.append($tr);

                $selP.on("change", function () {
                    refillCloneBulkChildSelect($selS, children, parents, $(this).val());
                });
                if (parents.length === 1) {
                    $selP.val(String(parents[0].id)).trigger("change");
                } else {
                    // Proposition automatique par nom identique (catégorie/sous-catégorie)
                    var wantedParent = normTxt(pair.label_cat || "");
                    var wantedChild = normTxt(pair.label_ss || "");
                    if (wantedParent !== "") {
                        var matchedParent = null;
                        parents.forEach(function (p) {
                            if (matchedParent === null && normTxt(p.label || "") === wantedParent) {
                                matchedParent = p;
                            }
                        });
                        if (matchedParent && matchedParent.id) {
                            $selP.val(String(matchedParent.id)).trigger("change");
                            if (wantedChild === "(categorie)" || wantedChild === "(catégorie)") {
                                if ($selS.find("option[value='" + matchedParent.id + "']").length > 0) {
                                    $selS.val(String(matchedParent.id));
                                }
                            } else if (wantedChild !== "") {
                                var matchedChild = null;
                                (children[String(matchedParent.id)] || children[matchedParent.id] || []).forEach(function (c) {
                                    if (matchedChild === null && normTxt(c.label || "") === wantedChild) {
                                        matchedChild = c;
                                    }
                                });
                                if (matchedChild && matchedChild.id) {
                                    $selS.val(String(matchedChild.id));
                                }
                            }
                        }
                    }
                }
            });

            var savedCategories = {};
            if (previewData.saved_mapping && typeof previewData.saved_mapping === "object") {
                if (
                    previewData.saved_mapping.categories &&
                    typeof previewData.saved_mapping.categories === "object"
                ) {
                    savedCategories = previewData.saved_mapping.categories;
                } else if (
                    previewData.saved_mapping.map &&
                    typeof previewData.saved_mapping.map === "object"
                ) {
                    savedCategories = previewData.saved_mapping.map;
                }
            }
            prefillCloneBulkMapping($m, savedCategories, children, parents);

            var $resp = $m.find(".__clone_bulk_resp_wrap");
            var $intro = $m.find(".__clone_bulk_resp_intro");
            var names = (previewData.source_responsables || []).join(", ");
            $resp.show();
            if (previewData.target_has_responsables) {
                $intro.text(
                    "L'édition cible a déjà un responsable d'inscription. Tu peux tout de même choisir le mode de gestion."
                );
            } else {
                $intro.text(
                    names
                        ? "Sur l'édition d'origine : " + names + "."
                        : "Aucun responsable listé sur l'édition d'origine (vous pouvez quand même en ajouter un sur la cible)."
                );
            }
            var $selU = $m.find(".__clone_bulk_resp_user");
            $selU.empty().append($('<option value=""/>').text("— Choisir —"));
            (previewData.target_pick_users || []).forEach(function (u) {
                $selU.append($("<option/>").val(u.user_id).text(u.label || "#" + u.user_id));
            });
            $m.find("input[name=_clone_prof_radio][value=keep]").prop("checked", true);
            $m.find("input[name=_clone_resp_radio][value=none]").prop("checked", true);
            $m.find("#_clone_keep_qr_checkbox").prop("checked", false);
            $m.find(".__clone_bulk_resp_select_wrap").hide();

            $m.data("preview", previewData);
            $m.data("targetEdition", targetEdition);
            $m.data("ids", ids);
        }

        function openCloneBulkModal(targetEdition, targetLabel, ids) {
            var $m = $("#_modal_clone_bulk");
            if ($m.length < 1) {
                alert("Interface de clonage indisponible sur cette page.");
                return;
            }
            $m.addClass("_show");
            $("html,body").css("overflow", "hidden");
            $m.find(".__clone_bulk_error").hide().text("");
            $m.find(".__clone_bulk_body").hide();
            $m.find(".__clone_bulk_loading").show();
            $m
                .find(".__clone_bulk_target_label")
                .text(
                    "Édition cible : « " +
                        targetLabel +
                        " » (" +
                        ids.length +
                        " fiche(s) sélectionnée(s))."
                );

            if (!window.AGP_CLONE_BULK || !window.AGP_CLONE_BULK.previewUrl) {
                $m.find(".__clone_bulk_loading").hide();
                $m.find(".__clone_bulk_error").show().text("Configuration de prévisualisation indisponible.");
                return;
            }

            var params = new URLSearchParams();
            params.set("target_edition_id", String(targetEdition));
            params.set("user_ids", JSON.stringify(ids));

            fetch(window.AGP_CLONE_BULK.previewUrl, {
                method: "POST",
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded",
                    "X-Requested-With": "XMLHttpRequest",
                },
                body: params,
                credentials: "same-origin",
            })
                .then(function (r) {
                    return r.text().then(function (text) {
                        var j = {};
                        try {
                            j = text ? JSON.parse(text) : {};
                        } catch (ignore) {
                            j = {};
                        }
                        return { ok: r.ok, status: r.status, j: j, raw: text };
                    });
                })
                .then(function (res) {
                    $m.find(".__clone_bulk_loading").hide();
                    var msg =
                        (res.j && res.j.error) ||
                        (res.j && res.j.message) ||
                        (res.j && res.j.title) ||
                        (res.status >= 400 ? "HTTP " + res.status : "");
                    if (!res.ok || msg) {
                        if (!msg && res.raw && res.raw.indexOf("<!") === 0) {
                            msg = "Réponse HTML (session expirée ou URL incorrecte) — rechargez la page.";
                        }
                        $m.find(".__clone_bulk_error").show().text(msg || "Erreur lors du chargement.");
                        return;
                    }
                    renderCloneBulkModal($m, res.j, targetEdition, ids);
                    $m.find(".__clone_bulk_body").show();
                })
                .catch(function () {
                    $m.find(".__clone_bulk_loading").hide();
                    $m.find(".__clone_bulk_error").show().text("Erreur réseau.");
                });
        }

        $(document).on("change", "input[name=_clone_resp_radio]", function () {
            var v = $("input[name=_clone_resp_radio]:checked").val();
            $(".__clone_bulk_resp_select_wrap").toggle(v === "pick");
        });

        function normTxt(v) {
            return (v || "")
                .toString()
                .normalize("NFD")
                .replace(/[\u0300-\u036f]/g, "")
                .trim()
                .toLowerCase();
        }

        $(document).on("click", "._close_modal_clone_bulk", function () {
            $("#_modal_clone_bulk").removeClass("_show");
            $("html,body").css("overflow", "auto");
        });

        $(document).on("click", ".__clone_bulk_confirm", function () {
            var $m = $("#_modal_clone_bulk");
            var previewData = $m.data("preview");
            var targetEdition = $m.data("targetEdition");
            var ids = $m.data("ids");
            if (!previewData || !ids) {
                return;
            }

            var map = {};
            var mapOk = true;
            $m.find(".__clone_bulk_map_table tbody tr").each(function () {
                var $tr = $(this);
                var $p = $tr.find(".__map_parent");
                var $s = $tr.find(".__map_ss");
                var key = $p.attr("data-key");
                var c = parseInt($p.val(), 10);
                var s = parseInt($s.val(), 10);
                if (!key || !c || !s) {
                    mapOk = false;
                }
                map[key] = { c: c, s: s };
            });
            if (!mapOk) {
                alert(
                    "Merci de renseigner la catégorie et la sous-catégorie cible pour chaque ligne."
                );
                return;
            }

            persistCloneBulkMapping(targetEdition, map);

            var prof = $("input[name=_clone_prof_radio]:checked").val() || "keep";
            var resp = $("input[name=_clone_resp_radio]:checked").val() || "none";
            var respUid = 0;
            if (resp === "pick") {
                respUid = parseInt($m.find(".__clone_bulk_resp_user").val(), 10) || 0;
                if (respUid < 1) {
                    alert(
                        "Merci de choisir un utilisateur pour le rôle de responsable d'inscription."
                    );
                    return;
                }
            }

            if (
                !previewData.target_has_responsables &&
                resp === "copy_source" &&
                (!previewData.source_responsables || !previewData.source_responsables.length)
            ) {
                if (
                    !confirm(
                        "Aucun responsable n'est défini sur l'édition d'origine. Continuer quand même ?"
                    )
                ) {
                    return;
                }
            }

            document.getElementById("_clone_target_edition").value = targetEdition;
            document.getElementById("_user_clone_ids").value = JSON.stringify(ids);
            document.getElementById("_clone_category_map").value = JSON.stringify(map);
            document.getElementById("_clone_profil_mode").value = prof;
            document.getElementById("_clone_resp_mode").value = resp;
            document.getElementById("_clone_resp_user_id").value =
                resp === "pick" ? String(respUid) : "";
            document.getElementById("_clone_keep_qr").value =
                $m.find("#_clone_keep_qr_checkbox").is(":checked") ? "1" : "0";

            $m.removeClass("_show");
            $("html,body").css("overflow", "auto");
            document.getElementById("clone_users_bulk").submit();
        });

        // cloner les fiches sélectionnées vers une autre édition (même événement)
        $(document).on("click", ".__clone_bulk_to_edition", function (e) {
            e.preventDefault();
            var targetEdition = $(this).data("target-edition");
            if (targetEdition === undefined || targetEdition === "") {
                return;
            }
            var rows = 0;
            if ($("input[name='btSelectAll']").is(":checked")) {
                rows = $("._table_users").bootstrapTable("getData");
            } else {
                rows = $("._table_users").bootstrapTable("getSelections");
            }
            if (rows.length < 1) {
                alert("Merci de sélectionner des fiches avant de les cloner vers une autre édition");
                return;
            }
            var label = (($(this).text() || "").trim()) || "l'édition choisie";
            var ids = rows.map(function (item) {
                return item.id;
            });
            openCloneBulkModal(targetEdition, label, ids);
        });

        // clonage unitaire vers édition avec options
        $(document).on("click", ".__clone_single_to_edition", function (e) {
            e.preventDefault();
            var userId = parseInt($(this).attr("data-user-id"), 10) || 0;
            var targetEdition = parseInt($(this).attr("data-target-edition"), 10) || 0;
            if (userId < 1 || targetEdition < 1) {
                return;
            }
            var userLabel = ($(this).attr("data-user-label") || "").trim();
            var targetLabel = ($(this).attr("data-target-label") || "").trim();
            var msg = "Cloner cette fiche vers « " + (targetLabel || "édition cible") + " » ?";
            if (userLabel !== "") {
                msg = "Cloner " + userLabel + " vers « " + (targetLabel || "édition cible") + " » ?";
            }

            var $m = $("#_modal_clone_single");
            if ($m.length < 1) {
                return;
            }
            $m.find(".__clone_single_target_label").text(msg);
            $m.data("userId", userId);
            $m.data("targetEdition", targetEdition);
            $m.find("#_clone_keep_qr_single_checkbox").prop("checked", false);
            $m.addClass("_show");
            $("html,body").css("overflow", "hidden");
        });

        $(document).on("click", "._close_modal_clone_single", function () {
            $("#_modal_clone_single").removeClass("_show");
            $("html,body").css("overflow", "auto");
        });

        $(document).on("click", ".__clone_single_confirm", function () {
            var $m = $("#_modal_clone_single");
            var userId = parseInt($m.data("userId"), 10) || 0;
            var targetEdition = parseInt($m.data("targetEdition"), 10) || 0;
            if (userId < 1 || targetEdition < 1) {
                return;
            }
            document.getElementById("_clone_source_user_id").value = String(userId);
            document.getElementById("_clone_target_edition_single").value = String(targetEdition);
            document.getElementById("_clone_keep_qr_single").value =
                $m.find("#_clone_keep_qr_single_checkbox").is(":checked") ? "1" : "0";

            $m.removeClass("_show");
            $("html,body").css("overflow", "auto");
            document.getElementById("clone_user_single").submit();
        });

        // export fiches / xls
        $(document).on("click", ".__export_fiches", function () {
            var rows = 0;
            if ($("input[name='btSelectAll']").is(':checked')) {
                rows = $("._table_users").bootstrapTable('getData');
            } else {
                rows = $("._table_users").bootstrapTable('getSelections');
            }
            if (rows.length > 0) {

                var ids = rows.map(function (item) {
                    return item.id;
                });


                $(".__wait_load").find(".__desc_wait").html("Nb de fiches exportées : " + ids.length + " <br> Merci de patienter pendant la création du fichier");
                $(".__wait_load").addClass("_show");

                setTimeout(function () {
                    $(".__wait_load").removeClass("_show");
                }, 4000);


                document.getElementById('_user_export').value = JSON.stringify(ids);
                document.getElementById('export_users').submit();

            } else {
                alert("Merci de sélectionner des fiches avant de les exporter");
            }

        });


        // suppression
        $(document).on("click", ".__delete_users", function () {
            var rows = 0;
            if ($("input[name='btSelectAll']").is(':checked')) {
                rows = $("._table_users").bootstrapTable('getData');
            } else {
                rows = $("._table_users").bootstrapTable('getSelections');
            }
            if (rows.length > 0) {
                if (confirm("vous êtes sur le point de supprimer définitivement " + rows.length + " fiches. \n Confirmez vous cette action ?")) {

                    var ids = rows.map(function (item) {
                        return item.id;
                    });

                    $(".__wait_load").find("span").html("Suppression des fiches en cours, <br> merci de patienter...");
                    $(".__wait_load").addClass("_show");


                    document.getElementById('_user_deletes').value = JSON.stringify(ids);
                    document.getElementById('delete_users').submit();
                }

            } else {
                alert("Merci de sélectionner des fiches avant de les supprimer");
            }

        });

        const runAsyncPrintJob = function (editionId, userIds) {
            const showWait = function (message) {
                const $wait = $(".__wait_load");
                if ($wait.length > 0) {
                    $wait.find("span").html(message);
                    $wait.addClass("_show");
                }
            };
            const hideWait = function () {
                const $wait = $(".__wait_load");
                if ($wait.length > 0) {
                    $wait.removeClass("_show");
                }
            };

            showWait("Préparation de l'impression des badges...<br>Merci de patienter.");
            const startUrl = _URL + "/editions/" + editionId + "/print-job/start";

            $.ajax({
                type: "POST",
                url: startUrl,
                dataType: "json",
                data: {list_users: JSON.stringify(userIds)},
                success: function (res) {
                    if (!res || !res.job_id) {
                        hideWait();
                        alert("Impossible de démarrer l'impression.");
                        return;
                    }

                    const pollUrl = _URL + "/editions/" + editionId + "/print-job/" + res.job_id + "/progress";
                    const downloadUrl = _URL + "/editions/" + editionId + "/print-job/" + res.job_id + "/download";

                    const poll = function () {
                        $.ajax({
                            type: "GET",
                            url: pollUrl,
                            dataType: "json",
                            cache: false,
                            success: function (state) {
                                const processed = parseInt(state.processed || 0, 10);
                                const total = parseInt(state.total || 0, 10);
                                if (total > 0) {
                                    showWait("Génération des PDF badges en cours...<br>" + processed + " / " + total + " traités");
                                }

                                if (state.status === "done") {
                                    hideWait();
                                    window.location.href = downloadUrl;
                                    return;
                                }

                                if (state.status === "failed") {
                                    hideWait();
                                    alert((state.error || "La génération des badges a échoué.") + "\nConsulte les logs pour le détail.");
                                    return;
                                }

                                setTimeout(poll, 1200);
                            },
                            error: function () {
                                setTimeout(poll, 1800);
                            }
                        });
                    };

                    setTimeout(poll, 800);
                },
                error: function () {
                    hideWait();
                    alert("Erreur serveur au démarrage de l'impression.");
                }
            });
        };

        // impression multi badges from users
        $(document).on("click", ".__print_badges", function () {
            var rows = 0;
            if ($("input[name='btSelectAll']").is(':checked')) {
                rows = $("._table_users").bootstrapTable('getData');
            } else {
                rows = $("._table_users").bootstrapTable('getSelections');
            }
            if (rows.length > 0) {

                var _message = "vous êtes sur le point d'imprimer " + rows.length + " badges. \n Confirmez vous cette action ?";
                if (rows.length > 150) {

                    var _message = "vous avez sélectionné trop de fiches, le maximum autorisé est de 150. \n Seuls les 150 premières fiches seront imprimées, confirmez-vous cette action ?";
                    //alert("Vous ne pouvez pas imprimer plus de 150 fiches en simultanné, merci de revoir votre sélection");
                    //return false;
                }

                //else {
                if (confirm(_message)) {

                    if (rows.length > 150) {
                        rows.splice(150);
                    }

                    var ids = rows.map(function (item) {
                        return item.id;
                    });

                    var editionId = parseInt($("input[name=edition_id]").val(), 10) || 0;
                    if (editionId > 0) {
                        runAsyncPrintJob(editionId, ids);
                    } else {
                        document.getElementById('list_users').value = JSON.stringify(ids);
                        document.getElementById('print_users').submit();
                    }


                }
                //}

            } else {
                alert("Merci de sélectionner des fiches avant de les imprimer");
            }

        });

        // Remove the _field_error class when the user changes the value of a select field
        $('select[required]').on('change', function () {
            $(this).removeClass('_field_error');
        });

        $(document).on("change", "input[name=leader_profil]", function () {
            var _is_responsable = $("input[name=responsable_inscription]").length;
            if ($(this).is(':checked') != 1 && _is_responsable > 0) {
                alert("Ce profil est également responsable d'inscription.\nSi vous enlevez le statut de chef d'équipe, l'accès responsable sera automatiquement supprimé ainsi que l'ensemble des fiches non transmises par cet utilisateur.");
            }
        });


        // $('._table_users').on('load-success.bs.table', function () {
        //     //_this.initParameters(_this);
        // });

        // load table user bootstrap
        // GROS VOLUMES / SERVER SIDE PAGINATION
        //alert(user.param_limit);
        if (typeof $.fn.bootstrapTable !== "function") {
            console.error("bootstrapTable plugin unavailable in Users.init");
            return;
        }
        $("._table_users").bootstrapTable({
            queryParams: function (params) {
                return {
                    filter: user.param_filter,
                    limit: user.param_limit,
                    search: params.search,
                    //offset: user.param_offset,
                    offset: params.offset,
                    sort: params.sort,
                    order: params.order,
                };
            },
            responseHandler: function (res) {
                return {
                    total: res.total,
                    total_real: res.total_real,
                    rows: res.rows
                };
            },
            onPageChange: function (number, size) {
                user.param_offset = user.param_limit * (number-1);
                //alert(user.param_offset);
            },
            onLoadSuccess: function (res, param, other) {


                let _show_rest = res.total;
                if (user.param_filter != "") {
                    _show_rest = res.total_real;
                }

                $(".search_results").show();
                $(".search_results_content").html("<strong>" + _show_rest + "</strong> résultat(s)");
                $("._contain_search").hide();
                _this.initParameters(_this);
            },
            onRefresh: function (e) {
                if (user.mod_multiple === false) {
                    // setTimeout(function () {
                    //     // var _nb = $('._table_users').bootstrapTable('getOptions').totalRows;
                    //     // $(".search_results").show();
                    //     // $(".search_results_content").html("<strong>" + _nb + "</strong> résultat(s)");
                    //     // $("._contain_search").hide();
                    // }, 1500);
                } else {
                    user.mod_multiple = false;
                }
            }
        });

        $("._table_users").on("post-header.bs.table", function () {
            const $tbl = $(this);
            const $wrap = $tbl.closest(".bootstrap-table").find(".fixed-table-toolbar .search").first();
            if (!$wrap.length || $wrap.find(".agp-bt-search-clear").length) {
                return;
            }
            const $input = $wrap.find("input.search-input").first();
            if (!$input.length) {
                return;
            }
            $wrap.css({ position: "relative", display: "inline-block" });
            $input.css("padding-right", "1.75rem");
            const $btn = $("<button>", {
                type: "button",
                class: "agp-bt-search-clear",
                "aria-label": "Vider la recherche",
                title: "Vider la recherche",
                html: "&times;"
            });
            $btn.css({
                position: "absolute",
                right: "6px",
                top: "50%",
                transform: "translateY(-50%)",
                border: "none",
                background: "transparent",
                fontSize: "1.2rem",
                lineHeight: 1,
                padding: "0 2px",
                color: "#6c757d",
                cursor: "pointer",
                zIndex: 2
            });
            const toggleClear = function () {
                $btn.toggle(!!(($input.val() || "").trim()));
            };
            $wrap.append($btn);
            $input.on("input.agpSearchClear keyup.agpSearchClear", toggleClear);
            toggleClear();
            $btn.on("click", function (e) {
                e.preventDefault();
                $tbl.bootstrapTable("resetSearch", "");
                toggleClear();
                $input.trigger("focus");
            });
        });

        // ACTUEL
        // $("._table_users").bootstrapTable({
        //     onRefresh: function () {
        //         if (user.mod_multiple === false) {
        //             setTimeout(function () {
        //                 var _nb = $('._table_users').bootstrapTable('getOptions').totalRows;
        //                 $(".search_results").show();
        //                 $(".search_results_content").html("<strong>" + _nb + "</strong> résultat(s) trouvés");
        //                 $("._contain_search").hide();
        //             }, 1500);
        //         } else {
        //             user.mod_multiple = false;
        //             alert("refresh after mod multiple");
        //         }
        //     }
        // });


        ////////////////////////////////////////////////////////////////////////////////
        // NAVIGATION ONGLETS
        $(document).on("click", "._onglet_nav", function () {

            var _onglet = $(this).data("onglet");
            $(this).addClass("_activ");
            $("._onglet_nav").not(this).removeClass("_activ");
            $("._content_user_modal[data-onglet=" + _onglet + "]").show();
            $("._content_user_modal[data-onglet!=" + _onglet + "]").hide();

        });

        //////////////////////////////////////////////////////////////////////////////////
        // VIEW ACCESS
        $(document).on("mousemove", "._view_access", function () {

            var _user = $(this).data("user");
            if (_user != user.view_user && user.view_user_load === false) {
                var _this_inside = $(this);
                user.view_user = _user;
                var _edition = $(this).data("edition");
                if (_this_inside.find(".__show_access").html() === "") {
                    user.view_user_load = true;
                    $.ajax({
                        url: _URL + "/user-access",
                        data: {
                            user_id: _user,
                            edition_id: _edition
                        },
                        type: "POST",
                        context: document.body
                    }).done(function (response) {

                        _this_inside.find(".__show_access").html(response);
                        //_this.prev(".__show_access").show();
                        user.view_user_load = false;
                        return false;
                    });
                }
            }

        });

        $(document).on("mouseleave", "._view_access", function () {
            user.view_user = undefined;
        });


        //////////////////////////////////////////////////////////////////////////////////
        // OPEN MODAL
        $(document).on("click", ".__open_modal_user", function () {

            $("._modal_user").addClass("_show");
            $("html,body").css("overflow", "hidden");

            var _try = new AirDatepicker('.airdate', {
                locale: localeFr,
                inline: false,
                range: false,
                //dateFormat: "dd-mm-yyyy"
            });

            // récupérer tous les champs obligatoires
            user.requiredFieldsArray = $("#form_user").find('input[required], select[required]').toArray();
            var input = $("input[name=user_mail]");
            var emailFieldIndex = user.requiredFieldsArray.indexOf(input[0]);
            if (emailFieldIndex !== -1) {
                user.emailRequired = true;
            }
            // var _montage = $("input[name=fiche_montage]").length;
            // if (_montage > 0) {
            //     _this.catMontage();
            // }

        });

        $(document).on("click", ".__open_modal_montage_user", function () {

            $("._modal_montage_user").addClass("_show");
            $("html,body").css("overflow", "hidden");

            var _try = new AirDatepicker('.airdate', {
                locale: localeFr,
                inline: false,
                range: false,
                //dateFormat: "dd-mm-yyyy"
            });

            // récupérer tous les champs obligatoires +  check si email obligatoire ou pas
            user.requiredFieldsArray = $("#form_user").find('input[required], select[required]').toArray();
            var input = $("input[name=user_mail]");
            var emailFieldIndex = user.requiredFieldsArray.indexOf(input[0]);
            if (emailFieldIndex !== -1) {
                user.emailRequired = true;
            }

        });

        $(document).on("click", "button[value=save_user]", function (e) {


            $("input").removeClass("_field_error");

            if (user.requiredFieldsArray != undefined && user.requiredFieldsArray.length > 0) {
                var _valid = true;
                $.each(user.requiredFieldsArray, function (index, field) {
                    if ($(field).val() === "") {
                        _valid = false;
                        $(field).addClass("_field_error");
                    }
                });
                if (_valid === false) {
                    e.preventDefault();
                    $("._onglet_nav[data-onglet=fiche]").addClass("_activ");
                    $("._onglet_nav[data-onglet!=fiche]").removeClass("_activ");
                    $("._content_user_modal[data-onglet=fiche]").show();
                    $("._content_user_modal[data-onglet!=fiche]").hide();
                    alert("Certains champs requis sont incomplets. \nMerci de contrôler l'ensemble des onglets avant de valider");
                }
            }

        });

        $(document).on("click", "._close_modal_user", function () {
            $("._modal_user").removeClass("_show");
            $("html,body").css("overflow", "auto");
        });

        $(document).on("click", "._close_modal_montage_user", function () {
            $("._modal_montage_user").removeClass("_show");
            $("html,body").css("overflow", "auto");
        });

        $(document).on("click", "._close_modal_search", function () {
            $("._modal_user_search").removeClass("_show");
            $("html,body").css("overflow", "auto");
        });

        //alert("ok");
        ///////////////////////////////////////////////////////////////////////////////
        // SAVE USER
        // $(document).on("click", "button[value=save_user]", function (e) {
        //     //alert("check");
        //     // // on controle si profil existe déjà
        //     // if ($("input[name=mod_user]").length === 0) {
        //     //     _this.checkMailUser();
        //     //     e.preventDefault();
        //     // }
        // });

        $(document).on("click", "._close_already_modal", function (e) {
            $("._already_profil").removeClass("_show");
        });

        ///////////////////////////////////////////////////////////////////////////////
        // GESTION CHEF EQUIPE
        $(document).on("change", "input[name=leader_profil]", function () {
            if ($(this).prop("checked") === true) {
                $("select[name=leader_id]").prop("selectedIndex", 0);
                $(".block-hide[data-id=admin_badges]").show();
            } else {
                $(".block-hide[data-id=admin_badges]").hide();
            }
        });

        $(document).on("change", "select[name=leader_id]", function () {
            $("input[name=leader_profil]").prop("checked", false);
            $("input[name=admin_profil]").prop("checked", false);
            $(".block-hide[data-id=admin_badges_pwd]").hide();
            $(".block-hide[data-id=admin_badges]").hide();
        });

        ///////////////////////////////////////////////////////////////////////////////
        // GESTION ADMIN BADGES
        $(document).on("change", "input[name=admin_profil]", function () {
            if ($(this).prop("checked") === true) {
                $(".block-hide[data-id=admin_badges_pwd]").show();
            } else {
                $(".block-hide[data-id=admin_badges_pwd]").hide();
            }
        });

        ///////////////////////////////////////////////////////////////////////////////
        // AJOUT ADMIN FROM UTILISATEUR
        $(document).on("click", ".__open_add_user_admin", function () {
            $(".__modal_users").toggle();
        });

        $(document).on("click", "._close_module", function () {
            $(".__modal_users").hide();
        });


        ///////////////////////////////////////////////////////////////////////////////
        // CATEGORIES
        $(document).on("change", "select[name=category_principale]", function () {

            var _id = $(this).val();
            if (_id != "") {
                $("select[name=category_secondaire] > option[data-cat-p!=" + _id + "]").hide();
                $("select[name=category_secondaire] > option[data-cat-p=" + _id + "]").show();
                $("select[name=category_secondaire] > option[value=all]").show();
            } else {
                $("select[name=category_secondaire] > option").show();
            }
            //$("select[name=category_secondaire] > option:first").prop("selected", true);
            $("select[name=category_secondaire] > option").prop("selected", false);
            // setTimeout(function(){
            //     alert($("select[name=category_secondaire] > option:hidden").length);
            //     //$("select[name=category_secondaire] > option:visible").eq(0).prop("selected", true);
            // },5000);

            var _first = $("select[name=category_secondaire] > option").filter(function () {
                return $(this).css("display") != "none";
            }).eq(0);
            _first.prop("selected", true);
            var __id = _first.val();

            _this.selectfromssCAT($("select[name=category_secondaire]"));

            //alert(__id);

            $.ajax({
                url: _URL + "/get_categories-passages",
                data: {
                    id: __id
                },
                type: "POST",
                context: document.body,
                success: function (data) {
                    _this.generatePassages(JSON.parse(data));
                }
            });


        });

        ///////////////////////////////////////////////////////////////////////////////
        // SS-CATEGORIES
        // init au chargement

        // if($(select[name="category_secondaire"]).length > 0){
        //     alert("test");
        // }

        $(document).on("change", "select[name=category_secondaire]", function () {

            var _id = $(this).val();
            var _cat_p = $(this).find(':selected').data('cat-p');

            if (_cat_p != "") {
                $("select[name=category_principale] > option[value=" + _cat_p + "]").prop("selected", true);
            }

            if (_id != "") {
                _this.selectfromssCAT($(this));
            } else {
                $("select[name=category_principale] > option:first").prop("selected", true);
            }

            //recuperation des passages
            $.ajax({
                url: _URL + "/get_categories-passages",
                data: {
                    id: _id
                },
                type: "POST",
                context: document.body,
                success: function (data) {
                    _this.generatePassages(JSON.parse(data));
                }
            });


        });


        ///////////////////////////////////////////////////////////////////////////////
        // ZONES
        $(document).on("change", "#all_zones", function () {

            var _check = $(this).prop("checked");
            if (_check === true) {
                $("input[name*='zones[']:checkbox").prop('checked', true);
            } else {
                $("input[name*='zones[']:checkbox").prop('checked', false);
            }

            _this.generatePassages();

        });

        ///////////////////////////////////////////////////////////////////////////////
        // JOURS
        $(document).on("change", "#all_jours,#all_mod_jours", function () {

            var _is_montage = $("input[name=montage]").length;

            var _check = $(this).prop("checked");
            if (_check === true) {
                $("input[name*='jours[']:checkbox").prop('checked', true);
                $("input[name*='mod_jours[']:checkbox").prop('checked', true);
            } else {
                $("input[name*='jours[']:checkbox").prop('checked', false);
                $("input[name*='mod_jours[']:checkbox").prop('checked', false);
            }
            if (_is_montage === 0) {
                _this.generatePassages();
            }
        });

        $(document).on("change", "input[name=all_group]", function () {

            var _id = $(this).attr("id");

            var _check = $(this).prop("checked");
            if (_check === true) {
                $("input[data-group-id=" + _id + "][name*='jours[']:checkbox").prop('checked', true);
                $("input[data-group-id=" + _id + "][name*='mod_jours[']:checkbox").prop('checked', true);
            } else {
                $("input[data-group-id=" + _id + "][name*='jours[']:checkbox").prop('checked', false);
                $("input[data-group-id=" + _id + "][name*='mod_jours[']:checkbox").prop('checked', false);
            }

        });

        $(document).on("change", "input[name*='jours[']:checkbox,input[name*='zones[']:checkbox", function () {
            var _is_montage = $("input[name=montage]").length;
            if (_is_montage === 0) {
                _this.generatePassages();
            }
        });

        ///////////////////////////////////////////////////////////////////////////
        // CATERING
        $(document).on("click", '._check_all', function () {
            var _id = $(this).data("restaurant");
            if ($(this).hasClass("_activ")) {
                $("._check_detail[data-restaurant=" + _id + "]").prop("checked", false);
            } else {
                $("._check_detail[data-restaurant=" + _id + "]").prop("checked", true);
            }
            $(this).toggleClass("_activ");
        });

        $(document).on("change", "._check_detail", function () {
            var _id = $(this).data("restaurant");
            $("._check_all[data-restaurant=" + _id + "]").removeClass("_activ");
        });
        ///////////////////////////////////////////////////////////////////////////////


        ///////////////////////////////////////////////////////////////////////////////
        // FILE
        $(document).on("click", "button[value=add_file]", function (e) {


            e.preventDefault();

            if (
                $("input[name=file_name]").val() != ""
                ||
                $("input[name=file]").val() != ""
            ) {
                //alert("inside");
                //var formData = $('#form_user_file').serialize();
                //var formData = new FormData($("#form_user_file"));

                var user_id = $('input[name="user_file_id"]').val();
                var edition_id = $('input[name="edition_id"]').val();
                var file_name = $('input[name="file_name"]').val();
                var file = $('input[name="file"]').prop('files')[0];
                var file_category = $('select[name="file_category"]').val();

                if (edition_id > 0 && file_name != "" && file) {

                    var formData = new FormData();
                    formData.append('edition_id', edition_id);
                    formData.append('file_name', file_name);
                    formData.append('file_category', file_category);
                    formData.append('file', file);
                    if (user_id != "") {
                        formData.append('user_id', user_id);
                    }

                    $.ajax({
                        url: _URL + "/add-user-file",
                        type: 'POST',
                        data: formData,
                        success: function (data) {

                            var result = $.parseJSON(data);


                            $("._no_history").hide();

                            var _app = ' <div class="__line row _flex _flex_wrap" data-id="' + result.id + '">' +
                                '<div class="col-md-3 _td _flex _flex_center"><span>' + result.cat_name + '</span></div>' +
                                '<div class="col-md-3 _td _flex _flex_center">' +
                                '<div> ' +
                                '<span class="_date">' + result.date + '</span>' +
                                '<span>' + result.name + '</span>' +
                                '</div>' +
                                '</div>' +
                                '<div class="col-md-3 _td _flex _flex_center">' +
                                '<form action="" class="text-center col-xs-12" method="post">' +
                                '<input type="hidden" name="file_id" value="' + result.id + '">' +
                                ' <button class="__ic" type="submit" name="_btn" value="download_file">\n' +
                                '<i class="fa-solid fa-file-arrow-down"></i>\n' +
                                '</button>' +
                                '</form>' +
                                '</div>' +
                                '<div class="col-md-3 _td _flex _flex_center">' +
                                '<form action="" class="text-center col-xs-12" method="post">' +
                                '<input type="hidden" name="file_id" value="' + result.id + '">' +
                                '<div class="__btns col-xs-12 text-center">\n' +
                                '<div class="__ic _delete_user_file" data-id="' + result.id + '">\n' +
                                '<i class="fa-solid fa-xmark"></i>\n' +
                                '</div>\n' +
                                '</div>' +
                                '</form>' +
                                '</div>' +
                                '</div>';

                            // var _app = '<div class="_bl_doc _flex _flex_wrap" data-id="' + result.id + '">\n' +
                            //     '<div class="_flex _flex_full">' +
                            //     ' <div>' +
                            //     '<span class="_date">' + result.date + '</span>\n' +
                            //     '<h3>' + result.name + '</h3>\n' +
                            //     '</div>' +
                            //     '</div>' +
                            //     '<div class="_flex _flex_center _btns_action">' +
                            //     '<form action="" method="post">' +
                            //     '<div><input type="hidden" name="file_id" value="' + result.id + '"></div>' +
                            //     '<button class="__ic" type="submit" name="_btn" value="download_file">\n' +
                            //     '<i class="fa-solid fa-file-arrow-down"></i>\n' +
                            //     '</button>' +
                            //     '<div class="__ic _delete_user_file" data-id="' + result.id + '">' +
                            //     '<i  class="fa-solid fa-xmark"></i>' +
                            //     '</div>' +
                            //     '</form>' +
                            //     '</div>' +
                            //     '</div>';
                            $("._body_docs").prepend(_app);
                            $("input[name=file_name]").val("");
                            $("input[name=file]").val("");
                            $('select[name=file_category]').prop('selectedIndex', 0);
                            $("._label_upload").html('<i class="fas fa-upload"></i><span>Sélectionnez un fichier</span>');
                        },
                        cache: false,
                        contentType: false,
                        processData: false
                    });

                } else {
                    alert("merci de contrôler les champs obligatoires avant de valider");
                }

            } else {
                alert("Merci de remplir les champs avant de valider");
            }


            return false;
        });

        $(document).on("click", "._delete_user_file", function (e) {

            if (confirm('Etes vous certain de vouloir supprimer ce fichier ?')) {
                var _id = $(this).data("id");
                $.ajax({
                    url: _URL + "/delete-user-file",
                    data: {
                        test: "ok",
                        id: _id
                    },
                    type: "POST",
                    context: document.body,
                    success: function (data) {
                        $(".__line[data-id=" + _id + "]").remove();
                    },
                    // cache: false,
                    // contentType: false,
                    // processData: false
                });
            }

        });


        ///////////////////////////////////////////////////////////////////////////////
        // PHOTO

        $(document).on("click", "._no_picture", function () {

            var _file = window.location.origin + "/img/AGP/no_picture_user.jpg";
            document.querySelector('.__badge_photo').style.backgroundImage = 'url(' + _file + ')';
            $("input[name=_img_required]").prop("checked", true);
            $("input[name=_no_picture]").val("Y");

            // _this.createInput();
            // var userImgInput = document.getElementsByName('user_img')[0];
            // if (userImgInput) {
            //     userImgInput.value = _file;
            // }

        });

        $(document).on("click", "._add_picture_file", function () {
            _this.createInput();
            user.inputFile.click();

            //$(".__wait_load").addClass("_show");

            user.inputFile.onchange = function (e) {
                //alert("->");

                var file = e.target.files[0];

                var maxSize = 3 * 1024 * 1024;
                if (file.size > maxSize) {
                    $(".__wait_load").removeClass("_show");
                    alert("Le fichier est trop volumineux. Veuillez choisir un fichier de moins de 3 Mo.");
                    return;
                }

                if (user.acceptedImageTypes.includes(file['type'])) {
                    var reader = new FileReader();
                    reader.readAsDataURL(file);
                    reader.onload = readerEvent => {
                        $(".__wait_load").removeClass("_show");
                        var content = readerEvent.target.result;
                        document.querySelector('.__badge_photo').style.backgroundImage = 'url(' + content + ')';
                    }
                    $("input[name=_img_required]").prop("checked", true);
                } else {
                    alert("Le fichier n'est pas une image");
                }
            };
        });

        ///////////////////////////////////////////////////////////////////////////////
        // WEBCAM

        $(document).on("click", "._cancel_webcam", function () {
            _this.closeCam();
            if (!input["name=_img_here"] && (!user.inputFile || !user.inputFile.files)) {
                $("input[name=_img_required]").prop("checked", false);
            }
        });

        $(document).on("click", "._take_picture", function () {
            var context = user.canvas.getContext("2d");
            user.canvas.width = user.videoWidth;
            user.canvas.height = user.videoHeight;
            context.drawImage(user.video, 0, 0, user.videoWidth, user.videoHeight);

            var myBlob = user.canvas.toBlob(blob => {
                var file = new File([blob], 'image.jpeg', {
                    type: blob.type,
                });
                _this.createInput();
                var container = new DataTransfer();
                container.items.add(file);
                user.inputFile.files = container.files;
            });

            var data = user.canvas.toDataURL("image/png");
            document.querySelector('.__badge_photo').style.backgroundImage = 'url(' + data + ')';
            _this.closeCam();
            $("input[name=_img_required]").prop("checked", true);
        });

        $(document).on("click", "._add_picture_webcam", function () {

            $("._modal_webcam").addClass("_show");

            user.canvas = document.getElementById('canvas');
            user.video = document.getElementById('videoCam');

            var All_mediaDevices = navigator.mediaDevices;
            if (!All_mediaDevices || !All_mediaDevices.getUserMedia) {
                alert("getUserMedia() not supported.");
                return;
            }


            All_mediaDevices.getUserMedia({
                audio: false,
                video: true
            }).then(function (stream) {

                user.stream = stream;
                user.video.srcObject = stream;
                user.video.play();
                _this.camEvents();

            })
                .catch(function (e) {
                    alert(e.message);
                    _this.closeCam();
                });

        });

    }


    catMontage() {

        $("._bl_st").removeClass("col-md-4 col-md-8").addClass("col-md-6");
        $(".__contain_coo").removeClass("col-md-4").addClass("col-md-6");
        $(".__contain_cat").removeClass("col-md-4").addClass("col-md-6");
        $(".__contain_ss_cat").remove();
        $("select[name=category_principale]").empty();
        $("select[name=category_principale]").append($('<option>', {
            value: 99,
            text: 'MONTAGE/DEMONTAGE'
        }));

    }

    initDoublons(_edition) {
        $("._modal_user_doublons").addClass("_show");
        $("html,body").css("overflow", "hidden");

        $.ajax({
            url: _URL + "/editions/get-doublons",
            data: {
                edition_id: _edition
            },
            type: "POST",
            context: document.body
        }).done(function (response) {

            let obj = JSON.parse(response);

            //console.log(obj.nb);
            //console.log(obj.doublons);
            $("._nb_doublons").html(obj.nb);
            $(".__list_doublons").html(obj.doublons);

            $("._table_doublons").bootstrapTable({
                pagination: false,
                pageSize: obj.doublons,
                locale: 'fr-FR',
                columns: [
                    {
                        field: 'btSelectItem',
                        checkbox: true,
                        formatter: function (value, row, index) {
                            // Get the user_id from the row data
                            var user_id = row.user_id;
                            // Create the name attribute for the checkbox input
                            var checkboxName = 'users[' + user_id + ']';
                            // Construct the checkbox input element with the custom name
                            return '<input name="' + checkboxName + '" type="checkbox">';
                        }
                    }
                ]
            });

            $("input[name=btSelectItem]").remove();
            $("._sub_header > .bs-checkbox").remove();


        });


    }


    // selection pour categorie secondaire => jours et zones actives
    selectfromssCAT(__this) {

        //console.log(__this);
        var _cat_j = __this.find(':selected').data('cat-jours');
        var _cat_z = __this.find(':selected').data('cat-zones');

        if (_cat_j != "") {

            var _array_jours;
            try {
                _array_jours = _cat_j.split("-");
            } catch (error) {
                _array_jours = [_cat_j];
            }

            //console.log(_array_jours);
            $("input[name*='jours[']:checkbox").prev("._check_activ").removeClass("_show");
            $("input[name*='jours[']:checkbox").prop('checked', false);
            $("input[name*='jours[']:checkbox").next("label").removeClass("_default").find('i').remove();
            _array_jours.forEach(function (id) {
                if (id != "") {
                    $("input[name='jours[" + id + "]'").prop('checked', true).prev("._check_activ").addClass("_show");
                }
            });
            // console.log(_array_jours);
            $("select[data-name=jours]").multipleSelect('setSelects', _array_jours);
        }

        if (_cat_z != "") {

            var _array_zones;
            try {
                _array_zones = _cat_z.split("-");
            } catch (error) {
                _array_zones = [_cat_z];
            }

            $("input[name*='zones[']:checkbox").prev("._check_activ").removeClass("_show");
            $("input[name*='zones[']:checkbox").prop('checked', false);
            $("input[name*='zones[']:checkbox").next("label").removeClass("_default").find('i').remove();
            _array_zones.forEach(function (id) {
                if (id != "") {
                    $("input[name='zones[" + id + "]'").prop('checked', true).prev("._check_activ").addClass("_show");
                    //$("input[name='zones[" + id + "]'").next("label").addClass("_default");
                }
            });
            //$("select[data-name=zones]").multipleSelect('setSelects', _array_zones)
        }
    }

    // creation du tableau de passages
    generatePassages(cat_passages, mod) {

        var _css_tab = ".user_passages";
        if (mod === true) {
            _css_tab = ".mod_user_passages";
        }

        let _this = this;

        let tab_dates = JSON.parse($("input[name=_tab_dates]").val());
        let tab_zones = JSON.parse($("input[name=_tab_zones]").val());

        if (mod === true) {
            var _jours = $("select[data-name=mod_jours]").multipleSelect('getSelects').map(Number);
            var _zones = $("select[data-name=mod_zones]").multipleSelect('getSelects').map(Number);
        } else {
            var _jours = $("input:checkbox:checked[name^='jours[']").map(function () {
                let name = $(this).attr("name");
                let value = name.replace(/[^\d]/g, '');
                return value;
            }).get().map(Number);
            var _zones = $("input:checkbox:checked[name^='zones[']").map(function () {
                let name = $(this).attr("name");
                let value = name.replace(/[^\d]/g, '');
                return value;
            }).get().map(Number);
        }

        //console.log(_jours);
        //return false;


        let _array_table_jours = [];
        let _array_table_zones = [];
        let _array_table_keys = [];

        if ($(_css_tab + " > tr").length > 0) {
            $(_css_tab + " > tr").each(function (id, item) {

                if ($(item).hasClass("no-records-found") != 1) {
                    let _key = $(item).data("key").split("-").map(Number);

                    if (_jours.indexOf(_key[0]) === -1 || _zones.indexOf(_key[1]) === -1) {
                        $(item).remove();
                    } else {
                        _array_table_keys.push($(item).data("key"));
                    }

                    //$(item).remove();
                    // let __get_type_jour = $(item).data("jour");
                    // if (_jours.indexOf(__get_type_jour) === -1) {
                    //     $(item).remove();
                    // } else {
                    //     if (_array_table_jours.indexOf(__get_type_jour) === -1) {
                    //         _array_table_jours.push(__get_type_jour);
                    //     }
                    // }
                    //
                    // let __get_type_zone = $(item).data("zone");
                    // if (_zones.indexOf(__get_type_zone) === -1) {
                    //     $(item).remove();
                    // } else {
                    //     if (_array_table_zones.indexOf(__get_type_zone) === -1) {
                    //         _array_table_zones.push(__get_type_zone);
                    //     }
                    // }
                } else {
                    $(item).remove();
                }

            });
        }

        //console.log(_array_table_keys);

        //return false;

        //console.log(_zones);
        //console.log(_array_table_zones);

        if (_zones.length > 0 && _jours.length > 0) {

            _jours.forEach(function (i) {
                let get_date = tab_dates.find(get_date => parseInt(get_date.id) === i);
                _zones.forEach(function (zone_id) {
                    let get_zone = tab_zones.find(get_zone => parseInt(get_zone.id) === zone_id);
                    let _key = i + "-" + zone_id;

                    let _passages = 1;
                    if (cat_passages != undefined) {
                        let check = cat_passages.find(element => element.key === _key);
                        if (check != undefined) {
                            _passages = check.passages;
                        }
                    }

                    if (_array_table_keys.indexOf(_key) === -1) {
                        var $add = '<tr data-key="' + i + "-" + zone_id + '" data-zone="' + zone_id + '" data-jour="' + i + '"><td class="uppercase">' + get_date.date + '</td><td>' + get_zone.label + '</td><td>' +
                            '<input type="text" class="text-center" name="access_passage[' + i + '][' + zone_id + ']" value="' + _passages + '">' +
                            '</td></tr>';
                        $(_css_tab).append($add);
                    } else {
                        if (_passages != 0) {
                            $("input[name='access_passage[" + i + "][" + zone_id + "]']").val(_passages);
                        }
                    }

                });

            });

            if (mod === true) {
                $("._bl_mod_passages").show();
            }

            _this.orderTable();

        }
    }


    // controle si mail est déjà pris par un utilisateur
    checkMailUser() {

        var _edition = $("input[name=edition_id]").val();
        var _mail = $("input[name=user_mail]").val();

        $.ajax({
            url: _URL + "/check-usermail",
            data: {
                mail: _mail,
                edition_id: _edition
            },
            type: "POST",
            context: document.body
        }).done(function (response) {

            if (response === "empty") {
                // on peut lancer l'enregistrement du profil
            } else {
                let obj = JSON.parse(response);

                if (obj.in_edition != undefined) {
                    $("._already_desc").html("Un utilisateur existe déjà avec cet email dans l'édition");
                    $("._btn_view_profil").show().attr("href", _URL + "/editions/" + _edition + "/users/" + obj.id);
                }

                $("._user_name").html(obj.name);
                $("input[name=already_user_id]").val(obj.id);
                $("._already_profil").addClass("_show");
            }

            //console.log(response);
            // _this_inside.find(".__show_access").html(response);
            // //_this.prev(".__show_access").show();
            // user.view_user_load = false;
            // return false;
        });
    }

    orderTable() {
        var rows = $(".user_passages > tr");
        //$("._nb_passages").html('(' + rows.length + ')');
        rows.sort(function (a, b) {
            var valueA = parseInt($(a).data('jour'));
            var valueB = parseInt($(b).data('jour'));
            return valueA - valueB;
        }).appendTo('.user_passages');
    }


    ////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // RECHERCHE UTILISATEUR
    initsearch(_this) {

        $(document).on("click", ".__open_search_user", function () {
            $("._modal_user_search").addClass("_show");
            $("html,body").css("overflow", "hidden");
            _this.reinitFilters();
        });

        $(document).on("click", "button[value=search_users]", function (e) {
            $("._modal_user_search").removeClass("_show");
            $("html,body").css("overflow", "auto");
            e.preventDefault();
            _this.user_search();
        });

        $(document).on("keypress", function (e) {
            // Check if the pressed key is Enter (key code 13)
            if (e.which === 13) {
                // Call a function to perform the search
                $("._modal_user_search").removeClass("_show");
                $("html,body").css("overflow", "auto");
                _this.user_search();
            }
        });

    }

    ////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // REINIT FILTERS EQUIPE/RESP INSCRIPTION..
    reinitFilters() {
        $('._table_users').bootstrapTable('filterBy', {});
        $("._btn_filter").removeClass("_activ");
        user.currentFilter = "";
        var icon = $('#reinitFilter');
        icon.removeClass('fa-xmark');
        icon.addClass('fa-chevron-down');
        $('._table_users').bootstrapTable('filterBy', {});
        $("._name_btn").html("Afficher");
    }

    ////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // MODIFICATION MULTIPLE USER
    initModification(_this) {

        $(document).on("click", "._close_mod_user", function () {
            $("._modal_user_mod").removeClass("_show");
            $("html,body").css("overflow", "auto");
        });

        $(document).on("click", ".__open_mod_users", function () {
            var rows = 0;
            if ($("input[name='btSelectAll']").is(':checked')) {
                rows = $("._table_users").bootstrapTable('getData');
            } else {
                rows = $("._table_users").bootstrapTable('getSelections');
            }

            // Fallback for pages using native checkbox fields instead of bootstrap-table selections.
            if (!Array.isArray(rows) || rows.length < 1) {
                var $selectionScope = $("._table_users").closest(".bootstrap-table");
                if ($selectionScope.length < 1) {
                    $selectionScope = $("._table_users");
                }

                var fallbackIds = $selectionScope
                    .find("input[name='selected_fiches[]']:checked, input[name='selected_await_fiches[]']:checked, input[name='btSelectItem']:checked")
                    .map(function () {
                        var raw = $(this).val() || $(this).attr("data-index");
                        var id = parseInt(raw, 10);
                        return Number.isNaN(id) ? null : id;
                    })
                    .get()
                    .filter(function (id) {
                        return id !== null;
                    });

                if (fallbackIds.length > 0) {
                    rows = fallbackIds.map(function (id) {
                        return {id: id};
                    });
                } else {
                    rows = [];
                }
            }
            if (rows.length > 0) {
                //console.log(rows);
                var selectedIds = rows
                    .map(function (row) {
                        var rawId = row.id !== undefined ? row.id : row.user_id;
                        var id = parseInt(rawId, 10);
                        return Number.isNaN(id) ? null : id;
                    })
                    .filter(function (id) {
                        return id !== null;
                    });
                var jsonString = JSON.stringify(selectedIds);

                $("input[name=_list_users]").val(jsonString);

                $("html,body").css("overflow", "hidden");
                $("._nb_users").html(rows.length);
                $("._nb_user_selected").html(rows.length);
                $("._modal_user_mod").addClass("_show");
            } else {
                alert("Merci de sélectionner des utilisateurs avant de cliquer");
            }

        });

        $(document).on("change", "input[name^='empty']", function (e) {
            var name = $(this).val();
            if ($(this).is(':checked')) {
                $("input[name=" + name + "]").val("");
                $("select[name=" + name + "]").val("");
            }
        });

        ///////////////////////////////////////////////////////////////////////////////
        // APPLICATION CATEGORIES -> ZONES / JOURS
        $(document).on("change", "select[name=mod_categories]", function () {

            var _id = $(this).val();

            if (_id != "") {

                $("input[name=affec_non_existant_days]").prop("checked", false).prop("disabled", true);
                $("input[name=affec_non_existant_zones]").prop("checked", false).prop("disabled", true);

                var _cat_j = $(this).find(':selected').data('cat-jours');
                var _cat_z = $(this).find(':selected').data('cat-zones');

                if (_cat_j != "") {
                    var _array_jours = _cat_j.split("-");
                    $("select[data-name=mod_jours]").multipleSelect('setSelects', _array_jours)
                }
                if (_cat_z != "") {
                    var _array_zones = _cat_z.split("-");
                    $("select[data-name=mod_zones]").multipleSelect('setSelects', _array_zones)
                }

                // RECUPERATION PASSAGES LISTE
                $.ajax({
                    url: _URL + "/get_categories-passages",
                    data: {
                        id: _id
                    },
                    type: "POST",
                    context: document.body,
                    success: function (data) {

                        //console.log(data);
                        _this.generatePassages(JSON.parse(data), true);
                    }
                });

                //_this.generatePassages();
            } else {
                $("input[name=affec_non_existant_days]").prop("disabled", false);
                $("input[name=affec_non_existant_zones]").prop("disabled", false);
            }

        });

        $(document).on("change", "select[name*='mod_jours['],select[name*='mod_zones[']", function () {
            //alert("->");
            _this.generatePassages(undefined, true);
        });

    }

    //////////////////////////////////////////////////////////////////
    // CAM

    // creation input photo
    createInput() {
        if ($("input[name=user_img]").length === 0) {
            user.inputFile = document.createElement('input');
            $(".__contain_badge").append(user.inputFile);
            user.inputFile.name = 'user_img';
            user.inputFile.type = 'file';
            user.inputFile.classList.add("_hidden");
            user.inputFile.accept = '.jpeg, .jpg, .png';
        }
    }

    // clean input photo
    cleanInput() {
        $("input[name=user_img]").remove();
        $("input[name=_img_required]").prop("checked", false);
    }


    camEvents() {

        let common = new Common();

        user.videoWidth = (common.$windowW / 100) * 35;

        user.video.addEventListener("canplay", function (evt) {
            user.videoHeight = (user.video.videoHeight / user.video.videoWidth) * user.videoWidth;
            user.video.setAttribute("width", user.videoWidth);
            user.video.setAttribute("height", user.videoHeight);
            user.canvas.setAttribute("width", user.videoWidth);
            user.canvas.setAttribute("height", user.videoHeight);
            $("._cam_btns").show();
            $("._load_cam").hide();
        });

    }

    // fermeture de l'objet cam
    closeCam() {
        $("._modal_webcam").removeClass("_show");
        $("._cam_btns").hide();
        $("._load_cam").show();
        user.stream.getTracks().forEach(function (track) {
            if (track.readyState == 'live' && track.kind === 'video') {
                track.stop();
            }
        });
    };


    /////////////////////////////////////////////////////////////////////////
    // PARAMETERS
    initParameters(_this) {
        try {
            const params = new URLSearchParams(window.location.search);
            const prefillCategoryId = parseInt(params.get("prefill_category_id") || "0", 10);
            const prefillCategorySsId = parseInt(params.get("prefill_category_ss_id") || "0", 10);
            if ((prefillCategoryId > 0 || prefillCategorySsId > 0) && typeof Cookies !== "undefined") {
                const editionId = $("input[name=edition_id]").val() || "";
                let criteria = {
                    edition_id: editionId,
                    photo: "",
                    birthcountry: "",
                    tri: "name",
                    tri_type: "asc",
                    leaders: [],
                    fonction: "",
                    name: "",
                    surname: "",
                    mail: "",
                    comm: "",
                    activ: "",
                    badge_validate: "",
                    badge_confirm: "",
                    badge_print: "",
                    badge_distributed: "",
                    jours: [],
                    societes: [],
                    zones: [],
                    spec: {},
                    categories: [],
                    sscategories: [],
                    is_montage: 0,
                    company: "",
                    created_by: ""
                };
                criteria.categories = prefillCategoryId > 0 ? [String(prefillCategoryId)] : [];
                criteria.sscategories = prefillCategorySsId > 0 ? [String(prefillCategorySsId)] : [];
                criteria.prefill_auto_apply = true;
                Cookies.set("searchCriteriaCookie", JSON.stringify(criteria), {expires: 365});

                params.delete("prefill_category_id");
                params.delete("prefill_category_ss_id");
                const newQuery = params.toString();
                window.history.replaceState({}, "", window.location.pathname + (newQuery ? "?" + newQuery : "") + window.location.hash);
            }
        } catch (e) {
            // no-op
        }

        let exist_Criteriums = Cookies.get('searchCriteriaCookie');

        if (exist_Criteriums) {
            _this.cookie_search();
        }

        try {
            const columnSettings = JSON.parse(localStorage.getItem('columnSettings')) || {};
            const $tableUsers = $('._table_users');

            $tableUsers.bootstrapTable('getOptions').columns[0].forEach(column => {
                const columnName = column.field;

                if (columnSettings[columnName] !== undefined) {
                    if (columnSettings[columnName]) {
                        $tableUsers.bootstrapTable('showColumn', columnName);
                    } else {
                        $tableUsers.bootstrapTable('hideColumn', columnName);
                    }
                }
            });
        } catch (error) {
            console.error('Error in initParameters:', error);
        }

        $("._table_users").on('column-switch.bs.table', function (e, name, checked) {
            try {
                const columnSettings = JSON.parse(localStorage.getItem('columnSettings')) || {};
                columnSettings[name] = checked;
                localStorage.setItem('columnSettings', JSON.stringify(columnSettings));
            } catch (error) {
                console.error('Error updating columnSettings:', error);
            }
        });
    }

    /////////////////////////////////////////////////////////////////////////
    // RECHERCHE USER
    user_search() {

        var _is_montage = $("input[name=montage]").length;


        var edition_id = $("input[name=edition_id]").val();
        var photo = $("select[name=search_photo]").val();
        var birthcountry = $("select[name=search_birthcountry]").val();
        var tri = $("select[name=search_tri]").val();
        var tri_type = $("input[name=search_tri_type]:checked").val();
        var leaders = $("select[name=search_leaders]").multipleSelect('getSelects');
        var societes = $("select[name=search_societe]").multipleSelect('getSelects');
        var fonction = $("input[name=search_function]").val();
        var name = $("input[name=search_name]").val();
        var surname = $("input[name=search_surname]").val();
        var mail = $("input[name=search_mail]").val();
        var comm = $("input[name=search_comm]").val();

        // validations selected
        var activ = $("select[name=user_activ]").val();
        //var no_categories = $("input[name=_no_categories]").is(":checked");
        var badge_validate = $("select[name=search_badge_validate]").val();
        var badge_confirm = $("select[name=search_badge_confirm]").val();
        var badge_print = $("select[name=search_badge_print]").val();
        var badge_distributed = $("select[name=search_badge_distributed]").val();
        var badge_distributed = $("select[name=search_badge_distributed]").val();


        // MOD SPECIFICI
        var searchSpecObject = {};

        //console.log($(".search_spec").length);

        $('.search_spec').each(function () {

            var fieldName = $(this).attr('name');


            if ($(this).is('select') && $(this).hasClass("multiple-select")) {
                var selectedValues = $(this).multipleSelect('getSelects');

                var nonEmptyValues = selectedValues.filter(function (value) {
                    return value !== "";
                });


                if (nonEmptyValues && nonEmptyValues.length > 0 && nonEmptyValues[Symbol.iterator]) {
                    // Extract the number from the field name
                    var match = fieldName.match(/\[(\d+)\]/);
                    if (match) {
                        var number = match[1];
                        searchSpecObject[number] = {};
                        searchSpecObject[number]["type"] = {};

                        searchSpecObject[number]["type"] = "select";
                        searchSpecObject[number]["values"] = nonEmptyValues;
                    }
                }
            } else {

                var fieldValue = $(this).val();

                if (fieldValue != "") {
                    var match = fieldName.match(/\[(\d+)\]/);
                    if (match) {
                        var number = match[1];
                        searchSpecObject[number] = {};
                        searchSpecObject[number]["type"] = {};
                        searchSpecObject[number]["type"] = "txt";
                        searchSpecObject[number]["values"] = fieldValue;
                    }
                }
            }
        });

        //console.log(searchSpecObject);
        //return false;


        var jours = "";
        if (_is_montage === 0) {
            var company = $("input[name=search_company]").val();
            var zones = $("select[name=search_zones]").multipleSelect('getSelects');
            var categories = $("select[name=search_categories]").multipleSelect('getSelects');
            var sscategories = $("select[name=search_sscategories]").multipleSelect('getSelects');
            jours = $("select[name=search_jours]").multipleSelect('getSelects');
        } else {
            var company = $("select[name=search_company]").multipleSelect('getSelects');
            var zones = "";
            var categories = "";
            //var jours = $("input[name=jours]:checked").val();
            jours = $("input:checkbox:checked[name^='jours[']").map(function () {
                let name = $(this).attr("name");
                let value = name.replace(/[^\d]/g, '');
                return value;
            }).get().map(Number);
        }


        if (
            jours != ""
            || birthcountry != ""
            || Object.keys(searchSpecObject).length > 0
            || photo != ""
            || mail != ""
            || company != ""
            || name != ""
            || surname != ""
            || zones.length > 0
            || leaders.length > 0
            || societes.length > 0
            //|| no_categories === true
            || categories.length > 0
            || sscategories.length > 0
            || activ != ""
            || comm != ""
            || badge_validate != ""
            || badge_confirm != ""
            || badge_print != ""
            || badge_distributed != ""
        ) {

            //console.log("inside");
            //console.log(searchSpecObject);


            var searchCriteria = {
                edition_id: edition_id,
                photo: photo,
                birthcountry: birthcountry,
                tri: tri,
                tri_type: tri_type,
                leaders: leaders,
                fonction: fonction,
                name: name,
                surname: surname,
                mail: mail,
                comm: comm,
                activ: activ,
                badge_validate: badge_validate,
                badge_confirm: badge_confirm,
                badge_print: badge_print,
                badge_distributed: badge_distributed,
                jours: jours,
                societes: societes,
                //company: company,
                zones: zones,
                spec: searchSpecObject,
                //no_categories: no_categories,
                categories: categories,
                sscategories: sscategories,
                is_montage: _is_montage,
            };

            var searchCriteriaJSON = JSON.stringify(searchCriteria);

            Cookies.set('searchCriteriaCookie', searchCriteriaJSON, {expires: 365});

            //console.log(societes);

            $("._table_users").bootstrapTable("refreshOptions", {
                url: _URL + "/search-users",
                queryParams: function (params) {
                    return {
                        filter: user.param_filter,
                        limit: user.param_limit,
                        search: "",
                        offset:params.offset,
                        //offset: user.param_offset,
                        search_users: true,
                        is_montage: _is_montage,
                        mail: mail,
                        comm: comm,
                        name: name,
                        photo: photo,
                        surname: surname,
                        societes: societes,
                        //company: company,
                        birthcountry: birthcountry,
                        fonction: fonction,
                        spec: searchSpecObject,
                        user_activ: activ,
                        badge_validate: badge_validate,
                        badge_confirm: badge_confirm,
                        badge_print: badge_print,
                        badge_distributed: badge_distributed,
                        edition_id: edition_id,
                        //no_categories: no_categories,
                        categories: categories,
                        sscategories: sscategories,
                        zones: zones,
                        jours: jours,
                        leaders: leaders,
                    };
                },
                onPageChange:function(number){
                    //alert(number);
                    user.param_offset = user.param_limit * (number-1);
                },
                responseHandler: function (res) {

                    // $("._table_users").bootstrapTable('refreshOptions', {
                    //     totalRows: res.total
                    // });

                    return {
                        total_real: res.total_real,
                        total: res.total,
                        rows: res.rows
                    };
                },
                onLoadSuccess: function (res) {
                    $(".search_results").show();
                    $("._btns_search").show();
                    $(".search_results_content").html("<strong>" + res.total + "</strong> résultat(s)");
                    $("._contain_search").hide();
                }
            });


            $("._table_users").bootstrapTable("refreshOptions", {
                sortName: tri,
                sortOrder: tri_type
            });

            $("._table_users").bootstrapTable('refresh');
            $("._table_users").bootstrapTable('selectPage', 1);

            return false;

            // $("._table_users").bootstrapTable("refresh", {
            //     url: _URL + "/search-users",
            //     silent: false,
            //     queryParams: function (params) {
            //         return {
            //             //filter: user.param_filter,
            //             limit: user.param_limit,
            //             //search: params.search,
            //             offset: params.offset,
            //
            //
            //             search_users: true,
            //             is_montage: _is_montage,
            //             mail: mail,
            //             comm: comm,
            //             name: name,
            //             photo: photo,
            //             surname: surname,
            //             company: company,
            //             birthcountry: birthcountry,
            //             fonction: fonction,
            //             spec: searchSpecObject,
            //             user_activ: activ,
            //             badge_validate: badge_validate,
            //             badge_confirm: badge_confirm,
            //             badge_print: badge_print,
            //             badge_distributed: badge_distributed,
            //             edition_id: edition_id,
            //             categories: categories,
            //             sscategories: sscategories,
            //             zones: zones,
            //             jours: jours,
            //             leaders: leaders,
            //         };
            //     },
            //     // query: {
            //     //     search_users: true,
            //     //     is_montage: _is_montage,
            //     //     mail: mail,
            //     //     comm: comm,
            //     //     name: name,
            //     //     photo: photo,
            //     //     surname: surname,
            //     //     company: company,
            //     //     birthcountry: birthcountry,
            //     //     fonction: fonction,
            //     //     spec: searchSpecObject,
            //     //     user_activ: activ,
            //     //     badge_validate: badge_validate,
            //     //     badge_confirm: badge_confirm,
            //     //     badge_print: badge_print,
            //     //     badge_distributed: badge_distributed,
            //     //     edition_id: edition_id,
            //     //     categories: categories,
            //     //     sscategories: sscategories,
            //     //     zones: zones,
            //     //     jours: jours,
            //     //     leaders: leaders,
            //     // },
            // });

        }

    }

    /////////////////////////////////////////////////////////////////////////
    // REFONTE AVEC COOKIE CRITERES
    cookie_search() {
        let searchCriteriaJSON = Cookies.get('searchCriteriaCookie');
        if (searchCriteriaJSON) {
            const searchCriteria = JSON.parse(searchCriteriaJSON);
            if (searchCriteria.edition_id === $("input[name=edition_id]").val()) {

                $(".filter_saved").addClass("_show");
                $("._btns_search").addClass("_show");


                $("select[name=search_photo]").val(searchCriteria.photo);
                $("select[name=search_birthcountry]").val(searchCriteria.birthcountry);
                $("select[name=search_tri]").val(searchCriteria.tri);
                $("select[name=search_tri_type]").val(searchCriteria.tri_type);
                $("input[name=search_function]").val(searchCriteria.fonction);
                $("input[name=search_name]").val(searchCriteria.name);
                $("input[name=search_surname]").val(searchCriteria.surname);
                $("input[name=search_mail]").val(searchCriteria.mail);
                $("input[name=search_comm]").val(searchCriteria.comm);
                $("select[name=user_activ]").val(searchCriteria.activ);
                $("select[name=search_badge_validate]").val(searchCriteria.badge_validate);
                $("select[name=search_badge_confirm]").val(searchCriteria.badge_confirm);
                $("select[name=search_badge_distributed]").val(searchCriteria.badge_distributed);
                $("select[name=search_badge_print]").val(searchCriteria.badge_print);
                $("input[name=search_company]").val(searchCriteria.company);


                var shouldAutoApply = searchCriteria.prefill_auto_apply === true;
                var _self = this;
                setTimeout(function () {
                    if (searchCriteria.categories && searchCriteria.categories.length > 0) {
                        $("select[name=search_categories]").multipleSelect('setSelects', searchCriteria.categories);
                    }
                    if (searchCriteria.sscategories && searchCriteria.sscategories.length > 0) {
                        $("select[name=search_sscategories]").multipleSelect('setSelects', searchCriteria.sscategories);
                    }
                    if (searchCriteria.leaders.length > 0) {
                        $("select[name=search_leaders]").multipleSelect('setSelects', searchCriteria.leaders);
                    }
                    if (searchCriteria.jours.length > 0) {
                        $("select[name=search_jours]").multipleSelect('setSelects', searchCriteria.jours);
                    }
                    if (searchCriteria.jours.length > 0) {
                        $("select[name=search_zones]").multipleSelect('setSelects', searchCriteria.zones);
                    }

                    if (shouldAutoApply) {
                        searchCriteria.prefill_auto_apply = false;
                        Cookies.set('searchCriteriaCookie', JSON.stringify(searchCriteria), {expires: 365});
                        _self.user_search();
                    }
                }, 900);


                // setTimeout(function () {
                //
                // }, 3000);

                var _nb = $('._table_users').bootstrapTable('getOptions').totalRows;
                $(".search_results").show();
                $(".search_results_content").html("<strong>" + _nb + "</strong> résultat.s");
                $("._contain_search").hide();


            }
        }

    }

    ////////////////////////////////
    // DISTRICBUTION
    user_distributed() {

        $(document).on("click", "button[value=valid_distributed]", function () {
            $('input,select').prop('required', false);
        });

        $("input[name=badge_distributed]").on("change", function () {
            let _checked = $(this).prop("checked");
            if (_checked === true) {
                $(".__distributed").addClass("_show");
            } else {
                $(".__distributed").removeClass("_show");
            }
        });

        $(document).on("click", "._cancel_distributed", function () {
            $(".__distributed").removeClass("_show");
            $("input[name=badge_distributed]").prop("checked", false);
        });

    }


}